import { uploadDataLakeNote } from '@ax/service';
import { UploadEHRNoteInput } from '@ax/service/src/ehr-interface';
import { useMutation } from '@tanstack/react-query';

export function useUploadDataLakeNoteApi() {
  const uploadDataLakeNoteMutation = useMutation({
    mutationKey: ['upload-datalake-note'],
    mutationFn: (data: UploadEHRNoteInput) => uploadDataLakeNote(data),
    onError: (error: any) => {
      return error;
    },
  });

  return uploadDataLakeNoteMutation;
}
